<template>
  <div class="nonebox">
    <drag-modal :visible="$store.state.dislog.Five" @cancel="reset" :title="'添加进度-' + litetit"
      :class="{ editbox: Edit }" width="882px">
      <div class="navbox" v-if="Edit">
        <Nscroll @getIndex="see" @delCopy="copydel" :openEdit="openEdit"></Nscroll>
        <div class="intopbtn" v-if="!isAllDis">
          <!-- <a-popconfirm title="确认新增此进度吗?" ok-text="确定" cancel-text="取消" @confirm="copyNew">
              <a-button icon="plus" v-if='!openEdit'>新增本进度</a-button>
            </a-popconfirm> -->
          <a-button v-if="
            $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.edit) &&
            $store.getters.publicPower
          " icon="edit" style="margin-left: 10px" @click="openEdit = !openEdit">{{ openEdit ? '修改' : '取消修改'
          }}</a-button>
        </div>
      </div>
      <a-spin :spinning="loading">
        <a-form-model ref="forms" :model="form" :rules="openEdit ? {} : rules" :label-col="{ span: 10 }"
          :wrapper-col="{ span: 24 }">
          <div class="fivelist">
            <a-button icon="plus" type="primary" ghost @click="addLi" v-if="!openEdit"
              style="margin-bottom: 20px">添加明细</a-button>
            <div class="overlist">
              <div class="blax" v-for="(i, index) in form.list" :key="index">
                <div class="btns" v-if="!openEdit && form.list.length > 1" style="position: absolute; right: 0">
                  <a-icon type="minus-circle" class="i del" @click="del(index)" />
                </div>
                <div class="htit">明细{{ index + 1 }}</div>
                <div class="dul">
                  <div class="li">
                    <div class="input" style="max-width: 50%">
                      <a-form-model-item :label="toTypeName(step, '开庭') + '时间'" :wrapper-col="{ span: 18 }"
                        :label-col="{ span: 6 }" :prop="'list.' + index + '.time'" :rules="{
                          required: true,
                          message: '请选择',
                          trigger: 'change',
                        }">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 265px" />
                      </a-form-model-item>
                    </div>
                    <div class="input" style="max-width: 50%">
                      <a-form-model-item :label="step == 53 ? '申请人代理人' : '开庭代理人'" :wrapper-col="{ span: 18 }"
                        :label-col="{ span: 6 }" :prop="'list.' + index + '.agent'" :rules="{
                          required: true,
                          message: '请输入',
                          trigger: 'blur',
                        }">
                        <a-input v-model="i.agent" style="width: 280px" placeholder="请输入" :disabled="openEdit" />
                        <!-- <b>{{$store.state.cause.agent}}</b> -->
                      </a-form-model-item>
                    </div>
                  </div>
                  <div class="licter" v-if="!openEdit">
                    <label>补充材料:</label>
                    <div class="rmain">
                      <a href="javascript:void(0);" @click="plusAdd(index, 1)">电子</a>
                      <a href="javascript:void(0);" @click="plusAdd(index, 2)">微信</a>
                      <a href="javascript:void(0);" @click="plusAdd(index, 3)">现场</a>
                      <a href="javascript:void(0);" @click="plusAdd(index, 4)">邮寄</a>
                    </div>
                  </div>
                  <div class="ilikecon">
                    <div class="ilikebox" v-for="(k, ind) in i.supp">
                      <div class="likebox" v-if="k.type == 1">
                        <div class="htit">
                          补充材料：电子
                          <span @click="sdel(index, ind)" v-if="!openEdit">
                            <a-icon type="minus-circle" />
                          </span>
                        </div>
                        <a-row :gutter="24">
                          <a-col :span="8">
                            <a-form-model-item label="平台名称" :prop="'list.' + index + '.supp.' + ind + '.platform'"
                              :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                              <a-input v-model="k.platform" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="材料名称" :prop="'list.' + index + '.supp.' + ind + '.filename'
                              " :rules="{
                                required: true,
                                message: '请输入材料名称',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.filename" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="补充时间" :prop="'list.' + index + '.supp.' + ind + '.time'" :rules="{
                              required: true,
                              message: '请选择补充时间',
                              trigger: 'change',
                            }">
                              <a-date-picker v-model="k.time" placeholder="请选择" show-time type="date"
                                valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                                style="width: 100%" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col :span="24">
                            <a-form-model-item label="备注" :prop="'list.' + index + '.supp.' + ind + '.comment'
                              ">
                              <a-input v-model="k.comment" :disabled="openEdit" type="textarea" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                      </div>
                      <div class="likebox" v-if="k.type == 2">
                        <div class="htit">
                          补充材料：微信
                          <span @click="sdel(index, ind)" v-if="!openEdit">
                            <a-icon type="minus-circle" />
                          </span>
                        </div>
                        <a-row :gutter="24">
                          <a-col :span="8">
                            <a-form-model-item label="对方微信号" :prop="'list.' + index + '.supp.' + ind + '.wx'" :rules="{
                              required: true,
                              message: '请输入对方微信号',
                              trigger: 'blur',
                            }">
                              <a-input v-model="k.wx" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="材料名称" :prop="'list.' + index + '.supp.' + ind + '.filename'
                              " :rules="{
                                required: true,
                                message: '请输入材料名称',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.filename" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="补充时间" :prop="'list.' + index + '.supp.' + ind + '.time'" :rules="{
                              required: true,
                              message: '请输入补充时间',
                              trigger: 'change',
                            }">
                              <a-date-picker v-model="k.time" placeholder="请选择" show-time type="date"
                                valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                                style="width: 100%" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col :span="24">
                            <a-form-model-item label="备注" :prop="'list.' + index + '.supp.' + ind + '.comment'
                              ">
                              <a-input v-model="k.comment" :disabled="openEdit" type="textarea" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                      </div>
                      <div class="likebox" v-if="k.type == 3">
                        <div class="htit">
                          补充材料：现场
                          <span @click="sdel(index, ind)" v-if="!openEdit">
                            <a-icon type="minus-circle" />
                          </span>
                        </div>
                        <a-row :gutter="24">
                          <a-col :span="8">
                            <a-form-model-item label="补充提交人" :prop="'list.' + index + '.supp.' + ind + '.submiter'
                              " :rules="{
                                required: true,
                                message: '请输入补充提交人',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.submiter" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="材料名称" :prop="'list.' + index + '.supp.' + ind + '.filename'
                              " :rules="{
                                required: true,
                                message: '请输入材料名称',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.filename" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="补充时间" :prop="'list.' + index + '.supp.' + ind + '.time'" :rules="{
                              required: true,
                              message: '请输入补充时间',
                              trigger: 'change',
                            }">
                              <a-date-picker v-model="k.time" placeholder="请选择" show-time type="date"
                                valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                                style="width: 100%" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col :span="24">
                            <a-form-model-item label="备注" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }" :prop="'list.' + index + '.supp.' + ind + '.comment'
                              ">
                              <a-input v-model="k.comment" :disabled="openEdit" type="textarea" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                      </div>
                      <div class="likebox" v-if="k.type == 4">
                        <div class="htit">
                          补充材料：邮寄
                          <span @click="sdel(index, ind)" v-if="!openEdit">
                            <a-icon type="minus-circle" />
                          </span>
                        </div>
                        <a-row :gutter="24">
                          <a-col :span="8">
                            <a-form-model-item label="单号" :prop="'list.' + index + '.supp.' + ind + '.ship_no'
                              " :rules="{
                                required: true,
                                message: '请输入单号',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.ship_no" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                          <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                        </a-form-model-item> -->
                            <a-form-model-item label="联系方式" :prop="'list.' + index + '.supp.' + ind + '.tel'" :rules="{
                              required: true,
                              message: '请输入联系方式',
                              trigger: 'blur',
                            }">
                              <a-input v-model="k.tel" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="材料名称" :prop="'list.' + index + '.supp.' + ind + '.filename'
                              " :rules="{
                                required: true,
                                message: '请输入材料名称',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.filename" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                        <a-row :gutter="24">
                          <a-col :span="8">
                            <a-form-model-item label="收件人" :prop="'list.' +
                              index +
                              '.supp.' +
                              ind +
                              '.receive_name'
                              " :rules="{
                                required: true,
                                message: '请输入收件人',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.receive_name" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="寄出时间" :prop="'list.' + index + '.supp.' + ind + '.ship_time'
                              " :rules="{
                                required: true,
                                message: '请选择寄出时间',
                                trigger: 'change',
                              }">
                              <a-date-picker v-model="k.ship_time" placeholder="请选择" show-time type="date"
                                valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                                style="width: 100%" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="">
                              <label v-if="openEdit">{{
                                k.gout == 'a'
                                  ? '签收时间:'
                                  : k.gout == 'b'
                                    ? '拒收时间:'
                                    : '无'
                              }}</label>
                              <a-radio-group v-model="k.gout" :disabled="openEdit" size="small"
                                style="white-space: nowrap" v-else>
                                <a-radio-button :value="null"
                                  style=" width: 64px; text-align: center; font-size: 12px;">无</a-radio-button>
                                <a-radio-button :value="'a'"
                                  style="width: 68px;font-size: 12px;text-align: center;">签收时间</a-radio-button>
                                <a-radio-button :value="'b'"
                                  style="width: 68px;font-size: 12px;text-align: center;">拒收时间</a-radio-button>
                              </a-radio-group>
                              <a-date-picker v-model="k.receive_time" placeholder="请选择" show-time type="date"
                                valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="k.gout == 'a'"
                                :disabled="openEdit" style="width: 100%" />
                              <a-date-picker v-model="k.return_time" placeholder="请选择" show-time type="date"
                                valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                                style="width: 100%" v-if="k.gout == 'b'" />
                              <a-input disabled v-if="!k.gout" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                        <a-row :gutter="24">
                          <a-col :span="12">
                            <a-form-model-item label="邮寄地址" :prop="'list.' + index + '.supp.' + ind + '.addr'" :rules="{
                              required: true,
                              message: '请输入邮寄地址',
                              trigger: 'blur',
                            }">
                              <a-input v-model="k.addr" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="12">
                            <a-form-model-item label="备注" :prop="'list.' + index + '.supp.' + ind + '.comment'
                              ">
                              <a-input v-model="k.comment" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                      </div>
                    </div>
                  </div>
                  <div class="licter" v-if="!openEdit" style="margin-bottom: 0">
                    <label>接收材料:</label>
                    <div class="rmain">
                      <a href="javascript:void(0);" @click="plusAdd(index, 1, 1)">电子</a>
                      <a href="javascript:void(0);" @click="plusAdd(index, 2, 1)">微信</a>
                      <a href="javascript:void(0);" @click="plusAdd(index, 3, 1)">现场</a>
                      <a href="javascript:void(0);" @click="plusAdd(index, 4, 1)">邮寄</a>
                    </div>
                  </div>
                  <div class="ilikecon">
                    <div class="ilikebox" v-for="(k, ind) in i.accept_file">
                      <div class="likebox" v-if="k.type == 1">
                        <div class="htit">
                          接收材料：电子
                          <span @click="supdel(index, ind)" v-if="!openEdit">
                            <a-icon type="minus-circle" />
                          </span>
                        </div>
                        <a-row :gutter="24">
                          <a-col :span="8">
                            <a-form-model-item label="平台名称" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.platform'
                              " :rules="{
                                required: true,
                                message: '请输入平台名称',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.platform" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="材料名称" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.filename'
                              " :rules="{
                                required: true,
                                message: '请输入材料名称',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.filename" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="接收时间" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.time'
                              " :rules="{
                                required: true,
                                message: '请选择接收时间',
                                trigger: 'change',
                              }">
                              <a-date-picker v-model="k.time" placeholder="请选择" show-time type="date"
                                valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                                style="width: 100%" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col :span="24">
                            <a-form-model-item label="备注" :label-col="{ span: 6 }" :wrapper-col="{ span: 24 }" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.comment'
                              ">
                              <a-input v-model="k.comment" :disabled="openEdit" type="textarea" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                      </div>
                      <div class="likebox" v-if="k.type == 2">
                        <div class="htit">
                          接收材料：微信
                          <span @click="supdel(index, ind)" v-if="!openEdit">
                            <a-icon type="minus-circle" />
                          </span>
                        </div>
                        <a-row :gutter="24">
                          <a-col :span="8">
                            <a-form-model-item label="对方微信号" :prop="'list.' + index + '.accept_file.' + ind + '.wx'
                              " :rules="{
                                required: true,
                                message: '请输入对方微信号',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.wx" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="材料名称" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.filename'
                              " :rules="{
                                required: true,
                                message: '请输入材料名称',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.filename" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="接收时间" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.time'
                              " :rules="{
                                required: true,
                                message: '请输入接收时间',
                                trigger: 'change',
                              }">
                              <a-date-picker v-model="k.time" placeholder="请选择" show-time type="date"
                                valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                                style="width: 100%" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col :span="24">
                            <a-form-model-item label="备注" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.comment'
                              ">
                              <a-input v-model="k.comment" :disabled="openEdit" type="textarea" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                      </div>
                      <div class="likebox" v-if="k.type == 3">
                        <div class="htit">
                          接收材料：现场
                          <span @click="supdel(index, ind)" v-if="!openEdit">
                            <a-icon type="minus-circle" />
                          </span>
                        </div>
                        <a-row :gutter="24">
                          <a-col :span="8">
                            <a-form-model-item label="接收人" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.submiter'
                              " :rules="{
                                required: true,
                                message: '请输入接收人',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.submiter" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="材料名称" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.filename'
                              " :rules="{
                                required: true,
                                message: '请输入材料名称',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.filename" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="接收时间" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.time'
                              " :rules="{
                                required: true,
                                message: '请输入接收时间',
                                trigger: 'change',
                              }">
                              <a-date-picker v-model="k.time" placeholder="请选择" show-time type="date"
                                valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                                style="width: 100%" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col :span="24">
                            <a-form-model-item label="备注" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.comment'
                              ">
                              <a-input v-model="k.comment" :disabled="openEdit" type="textarea" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                      </div>
                      <div class="likebox" v-if="k.type == 4">
                        <div class="htit">
                          接收材料：邮寄
                          <span @click="supdel(index, ind)" v-if="!openEdit">
                            <a-icon type="minus-circle" />
                          </span>
                        </div>
                        <a-row :gutter="24">
                          <a-col :span="8">
                            <a-form-model-item label="单号" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.ship_no'
                              " :rules="{
                                required: true,
                                message: '请输入单号',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.ship_no" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                          <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                        </a-form-model-item> -->
                            <a-form-model-item label="联系方式" :prop="'list.' + index + '.accept_file.' + ind + '.tel'
                              " :rules="{
                                required: true,
                                message: '请输入联系方式',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.tel" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="材料名称" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.filename'
                              " :rules="{
                                required: true,
                                message: '请输入材料名称',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.filename" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                        <a-row :gutter="24">
                          <a-col :span="8">
                            <a-form-model-item label="接收人" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.receive_name'
                              " :rules="{
                                required: true,
                                message: '请输入接收人',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.receive_name" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="寄出时间" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.ship_time'
                              " :rules="{
                                required: true,
                                message: '请选择寄出时间',
                                trigger: 'change',
                              }">
                              <a-date-picker v-model="k.ship_time" placeholder="请选择" show-time type="date"
                                valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                                style="width: 100%" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="8">
                            <a-form-model-item label="">
                              <label v-if="openEdit">{{
                                k.gout == 'a'
                                  ? '签收时间'
                                  : k.gout == 'b'
                                    ? '拒收时间'
                                    : '无'
                              }}</label>
                              <a-radio-group v-model="k.gout" :disabled="openEdit" size="small"
                                style="white-space: nowrap" v-else>
                                <a-radio-button :value="null" style="
                                      width: 64px;
                                      text-align: center;
                                      font-size: 12px;
                                    ">无</a-radio-button>
                                <a-radio-button :value="'a'" style="
                                      width: 64px;
                                      font-size: 12px;
                                      text-align: center;
                                    ">签收时间</a-radio-button>
                                <a-radio-button :value="'b'" style="
                                      width: 64px;
                                      font-size: 12px;
                                      text-align: center;
                                    ">拒收时间</a-radio-button>
                              </a-radio-group>
                              <a-date-picker v-model="k.receive_time" placeholder="请选择" show-time type="date"
                                valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="k.gout == 'a'"
                                :disabled="openEdit" style="width: 100%" />
                              <a-date-picker v-model="k.return_time" placeholder="请选择" show-time type="date"
                                valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                                style="width: 100%" v-if="k.gout == 'b'" />
                              <a-input disabled v-if="!k.gout" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                        <a-row :gutter="24">
                          <a-col :span="12">
                            <a-form-model-item label="邮寄地址" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.addr'
                              " :rules="{
                                required: true,
                                message: '请输入邮寄地址',
                                trigger: 'blur',
                              }">
                              <a-input v-model="k.addr" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                          <a-col :span="12">
                            <a-form-model-item label="备注" :prop="'list.' +
                              index +
                              '.accept_file.' +
                              ind +
                              '.comment'
                              ">
                              <a-input v-model="k.comment" :disabled="openEdit" />
                            </a-form-model-item>
                          </a-col>
                        </a-row>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dul">
                  <div class="li">
                    <div class="input" style="max-width: 100%">
                      <a-form-model-item :label="toTypeName(step, '庭审') + '小结'" :prop="'list.' + index + '.chapter'"
                        :rules="{
                          required: true,
                          message: '请输入',
                          trigger: 'blur',
                        }">
                        <Textarea :content="i.chapter" @contentVal="
                          (element) => {
                            i.chapter = element
                          }
                        " :edit="openEdit" v-if="!loading" Hei="164px" :keyArr="['time', 'user']">
                          </Textarea>
                      </a-form-model-item>
                    </div>
                  </div>
                  <div class="li">
                    <div class="input" style="max-width: 100%">
                      <a-form-model-item :label="'原件是否留存' + (step == 53 ? '调解机构' : '法院')"
                        :prop="'list.' + index + '.origin_save'" :rules="{
                          required: true,
                          message: '请输入原件是否留存',
                          trigger: 'blur',
                        }">
                        <a-input v-model="i.origin_save" placeholder="请输入原件是否留存" :disabled="openEdit" type="textarea" />
                      </a-form-model-item>
                    </div>
                  </div>
                  <div class="li">
                    <div class="input" style="max-width: 100%">
                      <a-form-model-item :wrapper-col="{ span: 24 }" :prop="'list.' + index + '.files'" :rules="{
                        required: false,
                        message: '请上传附件',
                        trigger: 'change',
                      }" style="margin-top: 20px">
                        <Upload :fList="i.files" @upFileAfter="
                          (element) => {
                            i.files = element
                          }
                        " :edit="openEdit" v-if="!loading" />
                      </a-form-model-item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a-form-model-item :wrapper-col="{ span: 24 }" v-if="!openEdit" style="text-align: center">
            <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button type="primary" style="width: 148px"> 提交 </a-button>
            </a-popconfirm>
            <a-button style="
                  margin-left: 20px;
                  width: 148px;
                  background: #b2c9e1;
                  color: #fff;
                " @click="reset">取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </drag-modal>
  </div>
</template>

<script>
import Nscroll from '@/components/nscroll'
import Upload from '@/components/uploads'
import {
  mapGetters,
  mapActions
} from 'vuex'
import {
  dpjAdd,
  dpjEdit,
  dpjList
} from '@/server/speed'
import Textarea from '@/components/textarea'
import fy from '../fy'
import { toTypeName } from "@/assets/js/formData"
const FormItem = {
  time: null, //开庭时间	date	✓
  agent: null, //	代理人	array	✓
  origin_save: null, //	原件留存	array	✓
  chapter: [{
    content: '',
    user: '',
  },],
  files: [],
  accept_file: [],
  supp: [],
}
export default {
  name: 'Five',
  data() {
    return {
      data: [],
      fy: fy,
      isAllDis: this.$route.query.t,
      step: this.$store.state.StepLite,
      rules: {},
      loading: true,
      openEdit: false,
      form: {
        list: [JSON.parse(JSON.stringify(FormItem))],
      },
    }
  },
  computed: {
    ...mapGetters(['litetit', 'Edit']),
  },
  components: {
    Upload,
    Nscroll,
    Textarea,
  },
  created() {
    if (this.Edit) {
      this.$nextTick(() => {
        dpjList({
          cause_id: this.$store.state.cause.id,
          step: this.step
        }).then(
          (e) => {
            e.list.map((ele) => {
              ele.dpj.map((element) => {
                element.chapter = JSON.stringify(element.chapter) == '{}' ? [{ content: '' }] :
                  Object.keys(element.chapter).map(
                    (key) => element.chapter[key]
                  )
                if (JSON.stringify(element.supp) == '{}') {
                  element.supp = []
                } else {
                  let s = []
                  Object.keys(element.supp).map((ele) => {
                    if (element.supp[ele].type == 4) {
                      element.supp[ele].gout = !element.supp[ele].receive_time &&
                        !element.supp[ele].return_time ?
                        null :
                        element.supp[ele].receive_time ?
                          'a' :
                          'b'
                    }
                    s.push(element.supp[ele])
                  })
                  element.supp = s
                }
                if (JSON.stringify(element.accept_file) == '{}') {
                  element.accept_file = []
                } else {
                  let s = []
                  Object.keys(element.accept_file).map((ele) => {
                    if (element.accept_file[ele].type == 4) {
                      element.accept_file[ele].gout = !element.accept_file[ele].receive_time &&
                        !element.accept_file[ele].return_time ?
                        null :
                        element.accept_file[ele].receive_time ?
                          'a' :
                          'b'
                    }
                    s.push(element.accept_file[ele])
                  })
                  element.accept_file = s
                }
              })
            })
            this.$store.dispatch("settime", e.list[0].dpj[0].update_time)
            this.Infokey({
              key: 'infoList',
              value: e.list
            })
            this.see(0)
          }
        )
        this.openEdit = true
      })
    } else {
      this.loading = false
    }
  },
  methods: {
    toTypeName,
    gtLetter() {
      return (JSON.parse(localStorage.getItem('pName')) || [])
        .concat(this.fy)
        .filter((ele) => {
          return ele
        })
    },
    handleSearch(value) {
      this.data = !value ?
        [] :
        this.gtLetter().filter((ele) => {
          return ele.indexOf(value) >= 0
        })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove',
    }),
    addLi() {
      let item = JSON.parse(JSON.stringify(FormItem))
      item.id = 0
      this.form.list.push(item)
    },
    async copydel(index) {
      //删除进度
      await this.Newdel({
        index: index,
        formKey: [
          'chapter',
          'agent',
          'time',
          'origin_save',
          'supp',
          'id',
          'accept_file',
        ],
        valkey: 'dpj',
      }).then((e) => {
        this.form.list = JSON.parse(JSON.stringify(e))
        this.loading = false
      })
    },
    confirm() {
      this.$refs.forms.validate((valid) => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))
          let curIndex = this.$store.state.DisForm.curIndex
          let isEditCopyAdd =
            this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0 ?
              true :
              false //当前是否是在修改下的新增
          form.list.map((ele) => {
            //     ele.agent = JSON.parse(JSON.stringify(this.$store.state.cause.agent))
            if (ele.supp.length == 0) {
              delete ele.supp
            } else {
              ele.supp.map((ele1) => {
                if (ele1.type == 4) {
                  if (ele1.gout == 'a') {
                    delete ele1.return_time
                  } else if (ele1.gout == 'b') {
                    delete ele1.receive_time
                  } else {
                    delete ele1.return_time
                    delete ele1.receive_time
                  }
                  delete ele1.gout
                }
              })
            }
            if (ele.accept_file.length == 0) {
              delete ele.accept_file
            } else {
              ele.accept_file.map((ele1) => {
                if (ele1.type == 4) {
                  if (ele1.gout == 'a') {
                    delete ele1.return_time
                  } else if (ele1.gout == 'b') {
                    delete ele1.receive_time
                  } else {
                    delete ele1.return_time
                    delete ele1.receive_time
                  }
                  delete ele1.gout
                }
              })
            }
            if (ele.files && ele.files.length > 0) {
              ele.files = ele.files.map((ele) => {
                return ele.upload_id || ele
              })
            }
          })
          if (this.Edit && !isEditCopyAdd) {
            //修改
            let step_id = this.$store.state.DisForm.infoList[curIndex].id
            form.step_id = step_id
            for (let val in form) {
              if (!form[val]) {
                delete form[val]
              }
            }
            dpjEdit(form).then((e) => {
              this.$message.success({
                content: '修改成功',
                key: 'updatable'
              })
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.setKey()
              this.reset()
            })
          } else {
            form.cause_id = this.$store.state.cause.id
            form.step = this.$store.state.StepLite
            dpjAdd(form).then((e) => {
              this.$message.success({
                content: '新增成功',
                key: 'updatable'
              })
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.setKey()
              this.reset()
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    sdel(index, ind) {
      let supp = JSON.parse(JSON.stringify(this.form.list[index].supp))
      supp.splice(ind, 1)
      this.form.list[index].supp = supp
    },
    supdel(index, ind) {
      let supp = JSON.parse(JSON.stringify(this.form.list[index].accept_file))
      supp.splice(ind, 1)
      this.form.list[index].accept_file = supp
    },
    setKey() {
      let letter = JSON.parse(localStorage.getItem('pName')) || []
      if (this.gtLetter().indexOf(this.form.platform) < 0) {
        letter.push(this.form.platform)
        localStorage.setItem('pName', JSON.stringify(letter))
      }
    },
    plusAdd(index, type, lite) {
      let smForm = {
        type: type,
      }
      if (type == 4) {
        smForm.gout = null
      }
      if (lite) {
        this.form.list[index].accept_file.push(smForm)
      } else {
        this.form.list[index].supp.push(smForm)
      }
    },
    copyNew() {
      //新增复制进度
      this.loading = true
      let copyItem = {
        cause_id: null,
        id: 1,
        dpj: [JSON.parse(JSON.stringify(FormItem))],
        title: this.litetit,
      }
      this.addNew(copyItem).then((index) => {
        this.form.list = [JSON.parse(JSON.stringify(FormItem))]
        this.loading = false
      })
    },
    async see(index) {
      //查看切换 审批
      this.loading = true
      let form = this.form
      this.seeInfo({
        index: index,
        formKey: [
          'chapter',
          'agent',
          'time',
          'origin_save',
          'supp',
          'id',
          'accept_file',
        ],
        valkey: 'dpj',
      }).then((e) => {
        this.form.list = JSON.parse(JSON.stringify(e))
        this.loading = false
      })
    },
    del(index) {
      this.form.list.splice(index, 1)
    },
    reset() {
      this.reMove().then((e) => {
        this.$refs.forms.resetFields()
        this.$store.dispatch('openkey', {
          key: 'Five',
          by: false
        })
      })
    },
    // lisUpload(fileList) {
    //   this.form.files = fileList
    // },
  },
}
</script>

<style lang="less">
.fivelist {
  .ant-form-item-label {
    text-align: left;
  }

  .ant-form-item {
    margin-bottom: 10px;
  }
}
</style>

<style lang="less" scoped>
.ml20 {
  margin-left: 20px;
}

.overlist {
  overflow: auto;
  height: 500px;
  margin-bottom: 20px;

  .blax {
    background: #f3f6fb;
    border-radius: 4px;
    margin-bottom: 20px;
    position: relative;
  }
}

.htit {
  font-size: 16px;
  color: #333;
  line-height: 30px;
  padding: 10px 20px 10px;
}

.dul {
  // margin: 0 40px;
  padding: 10px 20px 0;

  .li {
    border-radius: 4px;
    display: flex;

    &:nth-child(1) {
      padding-top: 0;
    }

    .input {
      flex: 1;
      max-width: 33%;
    }

    &:nth-last-child(1) {
      margin: 0;
    }
  }
}

.table {
  margin-top: 20px;
  padding: 0 40px;

  table {
    width: 100%;
  }
}

.likebox {
  background: #f3f6fb;
  margin-bottom: 10px;
  border-radius: 8px;

  .htit {
    font-size: 16px;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;
    padding: 10px 20px 10px 0;

    span {
      color: #f00;
      cursor: pointer;
    }
  }
}

.morebar {
  display: flex;
  margin-bottom: 10px;
  height: 40px;
  align-items: center;

  &:nth-last-child(1) {
    margin-bottom: 0;
  }
}

.btns {
  width: 5%;
  display: flex;
  font-size: 20px;
  justify-content: space-between;
  padding-right: 20px;
  height: 40px;
  align-items: center;

  .i {
    cursor: pointer;
  }

  .add {
    color: #b0e0e6;
  }

  .del {
    color: #f00;
  }
}

.licter {
  overflow: hidden;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  label {
    float: left;
    font-size: 14px;
    text-align: right;
    color: #333;
    line-height: 30px;
    width: 70px;
    margin-right: 22px;
  }

  .clearbtn {
    float: left;
  }

  .rmain {
    // padding-left: 20px;
    // margin-left: 20px;
    float: left;

    a {
      width: 68px;
      line-height: 36px;
      background: #b2c9e1;
      border-radius: 4px;
      display: inline-block;
      margin-right: 20px;
      font-size: 14px;
      color: #fff;
      text-align: center;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
      }
    }
  }
}
</style>
